import React from 'react';
import {
  required,
  List,
  Datagrid,
  Create,
  SimpleForm,
  TextField,
  EditButton,
  ReferenceInput,
  AutocompleteInput,
  ReferenceField,
  Filter,
  TextInput,
  FunctionField,
} from 'react-admin';
import RejectPurchaseOrderBtn from './skills/RejectPurchaseOrderBtn';

const OrderFilter = (props) => (
  <Filter {...props}>
    <TextInput label="User Id" source="userId" />
    <TextInput label="PhoneNumber" source="phoneNumber" alwaysOn />
  </Filter>
);

const renderRejectButton = (status, id) => {
  if (status !== 'APPROVED') {
    return '';
  }

  return <RejectPurchaseOrderBtn id={id} />;
}

export const PurchaseOrderListForTimeRequest = props => (
  <List title="Уулзалтын захиалгууд" {...props} filters={<OrderFilter/>}>
    <Datagrid optimized>
      <TextField label="ID" source="id" />
      <ReferenceField label="Уулзалтын хүсэлт" source="items.0.productId" reference="mentoringTimeRequests">
        <TextField label="Нэр" source="id" />
      </ReferenceField>
      <ReferenceField source="userId" reference="users" label="Имэйл">
        <TextField source="email" />
      </ReferenceField>
      <TextField label="Төлбөр" source="items.0.amount" />
      <TextField label="Статус" source="status" />
      <FunctionField label="" render={record => renderRejectButton(record.status, record.id)} />
      <EditButton />
    </Datagrid>
  </List>
);

export const PurchaseOrderCreateForTimeRequest = props => (
  <Create title="Хөтөлбөрийн захиалга үүсгэх" {...props}>
    <SimpleForm>
      <ReferenceInput label="Хэрэглэгч" source="userId" reference="users" validate={[required()]}>
        <AutocompleteInput optionText="email" />
      </ReferenceInput>
      <ReferenceInput
        label="Уулзалтын хүсэлт"
        source="productId"
        filterToQuery={q => ({ id: q })}
        reference="mentoringTimeRequests"
        validate={[required()]}
      >
        <AutocompleteInput optionText="timeslot" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);
